<template>
	<div class="dialog-wrap">
		<div class="dialog-detail">
			<div class="title-wrap">
				<img src="../assets/img/close.png" class="close" @click="close">
				<h1>退款详情</h1>
			</div>
			
			<div class="refund-wrap">
				<ul class="refund-follow">
					<li v-for="(item, index) in refundList" :key="index">
						<div class="left">
							<div class="time">{{ item.create_time }}</div>
						</div>
			
						<div class="middle" :class="{finish: (index==0 && (item.content.indexOf('成功')!=-1))}"></div>
			
						<div class="right">
							<p>{{ item.content }}</p>
						</div>
						<div class="time-line" v-if="index != refundList.length - 1"></div>
					</li>
				</ul>
			</div>
			
			<ul class="refund-detail">
				<li>
					<div>退款金额</div>
					<span>￥{{ orderInfo.refund_price }}</span>
				</li>
				<li>
					<div>退款状态</div>
					<span>{{ refund_status | filterRefund }}</span>
				</li>
				<li>
					<div>退款编号</div>
					<span>{{ orderInfo.refund_number }}</span>
				</li>
				<li>
					<div>订单编号</div>
					<span>{{ orderInfo.order_code }}</span>
				</li>
				<li>
					<div>退回路径</div>
					<span>{{ orderInfo.pay_type | filterPay }}</span>
				</li>
				<li>
					<div>发起时间</div>
					<span>{{ orderInfo.refund_time }}</span>
				</li>
			</ul>
			
			<div class="btn-wrap">
				<div class="back" @click="backList">返回列表</div>
				<div class="refund" @click="operateOrder(6)" v-if="orderInfo.order_status==10 && refund_status == 1">不退款，继续处理</div>
			</div>
		</div>
	</div>

</template>
<script>
	import {
		getOrderRefundRecord,
		operateOrder
	} from '@/api/order'
	import {
		filterRefund,
		filterPay
	} from '@/filters/index';
	export default {
		props: {
			order_uuid: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				page_index: 1,
				page_size: 25,
                refund_status:"",    //退款状态
				refundList: [],
				orderInfo: {},
				clickOperate:true			//是否可以操作弹框
			};
		},

		created() {
			this.getOrderRefundRecord();
		},

		methods: {
			// 查询退款记录
			async getOrderRefundRecord() {
				const obj = {
					order_uuid: this.order_uuid
				};
				const {data,status} = await getOrderRefundRecord(obj);
				if (status !== 200) return
				this.refundList = data.data;
				this.orderInfo = data.order_info;
				if(this.refundList.length){
					this.refund_status = this.refundList[0].refund_status
				}
				this.refundList.forEach((item,index)=>{
					if(item.content == "用心淘同意退款"){
						item.content = "系统审核通过"
					}
				})
				if (this.orderInfo.uuid) {
					this.order_uuid = this.orderInfo.uuid
				}
			},

			// 确定撤销退款
			async operateOrder(type) {
				if(!this.clickOperate) {
					window.toast("请勿重复点击","txt");
					return;
				}
				this.clickOperate = false;
				setTimeout(()=>{
					this.clickOperate = true;
				},2000)
				const parmas = {
					type: type
				};
				const {
					data,
					status
				} = await operateOrder(this.order_uuid, parmas);
				if (status !== 200) return;
				this.getOrderRefundRecord()
				this.$message.success('撤销退款成功');
			},

			backList() {
				if (this.$route.path == '/order-list') {
					this.$emit('backList');
				} else {
					this.$router.push({
						path: './order-list'
					});
				}
			},
			close() {
				this.$emit('close')
			}
		}
	};
</script>

<style lang="scss" scoped>
	::-webkit-scrollbar {
		display: none;
	}
	
	.dialog-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		z-index: 9;
		top: 0;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
	
		.dialog-detail {
			position: relative;
			width: 600px;
			box-sizing: border-box;
			background: #FFFFFF;
			box-shadow: 0px 13px 7px 0px rgba(0, 0, 0, 0.06);
			height: 86%;
			overflow-y: auto;
			.close {
				position: absolute;
				right: 20px;
				top: 20px;
				width: 11px;
				height: 11px;
				cursor: pointer;
			}
		}
		
		h1 {
			@include font-style;
			font-size: 20px;
			color: #000000;
			padding: 20px;
			text-align: center;
		}
		
		.element::-webkit-scrollbar {
			display: none
		}
		.title-wrap{
			position: sticky;
			top: 0;
			background: #fff;
			z-index: 9;
			border-bottom: 1px solid #ededed;
		}

		.refund-wrap {
			margin: 0 40px;
			padding: 16px 0;
		}
		
		.refund-follow {
			background: #ffffff;
			box-sizing: border-box;
		
			li {
				display: flex;
				position: relative;
				padding-bottom: 20px;
		
				.left {
					width: 80px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					text-align: right;
					font-size: 18px;
		
					.time {
						font-size: 14px;
						color: #858585;
					}
				}
		
				.middle {
					width: 20px;
					height: 20px;
					margin: 0 30px;
					background: url(../assets/img/roll.png) no-repeat center;
					background-size: 100%;
					z-index: 2;
				}
		
				.finish {
					background: url(../assets/img/complete.png) no-repeat center;
					background-size: 100%;
				}
		
				.right {
					font-size: 16px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #999999;
		
					textarea {
						width: 100%;
						height: 80px;
						background: #fffbf7;
						box-sizing: border-box;
						padding: 16px 0 0 16px;
						resize: none;
						word-break: break-all;
						font-size: 14px;
						color: #858585;
						font-family: Microsoft YaHei;
					}
		
					p {
						margin-bottom: 18px;
					}
				}
		
				.time-line {
					position: absolute;
					left: 118px;
					height: 100%;
					border-left: 4px solid #e6e6e6;
				}
			}
		}
		
		.refund-detail {
			padding: 30px 40px;
		
			li {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 10px;
		
				div {
					@include font-style;
					color: #999999;
					font-size: 16px;
				}
		
				span {
					@include font-style;
					color: #333333;
					font-size: 16px;
				}
			}
		
			li:last-child {
				margin-bottom: 0;
			}
		}
		
		.btn-wrap {
			padding: 20px 0;
			display: flex;
			align-items: center;
			justify-content: center;
			.back {
				@include cursor-style;
				width: 180px;
				height: 34px;
				line-height: 34px;
				text-align: center;
				font-size: 14px;
				border-radius: 2px;
				color: #FF8D1C;
				background: #FFF3E6;
				border: 1px solid #FF8D1C;
			}
		
			.refund {
				@extend .back;
				margin-left: 30px;
				color: #999999;
				background: #FFFFFF;
				border: 1px solid #999999;
			}
		}
	}
</style>
